
    import { defineComponent } from 'vue'
    import L from 'leaflet'
    import "leaflet/dist/leaflet.css"
    import {LV95toWGS} from "swiss-projection"
    import LichenRecordMapPopup from "@/classes/LichenRecordMapPopup"
    import {mapConfig} from "@/config/app-settings";

    export default defineComponent({
        name: "Map",
      data () {
        return {
          map: {} as L.Map
        }
      },
      props: {
        features: { type: Array as () => LichenRecordMapPopup[], required: true }
      },
      computed: {
        defaultIcon(): L.Icon {
          return new (L.icon as any)({
            iconUrl: require('../../node_modules/leaflet/dist/images/marker-icon.png'),
            iconSize: [20, 30],
            iconAnchor: [15, 38],
            popupAnchor: [-5, -34]
          })
        }
      },
      mounted() {
        this.map = mapConfig('map-overview')
      },
      beforeUnmount() {
        if (this.map) {
          this.map.remove()
        }
      },
        watch: {
            features() {
                this.features.forEach((feature : LichenRecordMapPopup) => {
                  const coords = LV95toWGS([feature.X, feature.Y])
                  const popupTemplate =
                      `<b>${feature.TAXON_NAME}</b> (ID=${feature.RECORD_ID})
                        <br>
                        ${feature.X}/${feature.Y}
                        <br>
                        ${feature.RECORD_DATE}
                        <br>
                        ${feature.CERTAINTY}
                        `

                    L.marker([coords[1], coords[0]], {icon: this.defaultIcon})
                        .addTo(this.map as L.Map)
                        .bindPopup(popupTemplate)
                        .on('click', (data) => console.log(data) )
                })
            }
        }
    })
